<template>
  <div class="autocomplete is-expanded select is-fullwidth">
    <button
      ref="button"
      class="input is-fullwidth has-text-left"
      @focus="focused"
      @click="open"
      @blur="focus = false"
      @keyup.esc.prevent="isActive = false"
      @keydown.enter.prevent="enterPressed"
      @keydown.up.prevent="keyArrows('up')"
      @keydown.down.prevent="keyArrows('down')"
      @keyup.space.prevent="isActive = true"
      @keydown.tab="isActive = false"
    >
      {{ getName }}
    </button>

    <div
      v-show="isActive"
      ref="dropdown"
      class="dropdown-menu"
    >
      <div v-show="isActive" class="dropdown-content">
        <a
          v-for="(option, index) in data"
          :key="index"
          :class="{ 'is-hovered': hovered === option }"
          class="dropdown-item"
          @click="setSelected(option)"
        >
          <slot :row="option" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: null
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    field: {
      type: String,
      default: null
    },
    selectValue: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isActive: false,
      focus: false,
      hovered: null,
      selected: null,
      model: null
    }
  },
  computed: {
    whiteList () {
      const whiteList = []
      whiteList.push(this.$refs.button)
      whiteList.push(this.$refs.dropdown)
      // Add all chidren from dropdown
      if (this.$refs.dropdown !== undefined) {
        const children = this.$refs.dropdown.querySelectorAll('*')
        for (const child of children) {
          whiteList.push(child)
        }
      }

      return whiteList
    },
    getName () {
      if (this.field) {
        return this.selected ? this.selected[this.field] : ''
      } else {
        return this.selected
      }
    }
  },
  watch: {
    value () {
      this.updateValue()
    },
    model (input) {
      this.$emit('input', input)
      this.$emit('selected', this.selected)
    }
  },
  created () {
    this.updateValue()
    if (typeof document !== 'undefined') {
      document.addEventListener('click', this.clickedOutside)
    }
  },
  beforeDestroy () {
    if (typeof document !== 'undefined') {
      document.removeEventListener('click', this.clickedOutside)
    }
  },
  methods: {
    updateValue () {
      if (this.value) {
        const find = this.data.find(x => x.id === this.value)
        if (find) {
          this.setSelected(find)
        }
      } else {
        this.setSelected(null)
      }
    },
    open () {
      if (Date() !== this.focus) {
        this.isActive = !this.isActive
      }
    },
    focused () {
      this.focus = Date()
      this.isActive = true
    },
    enterPressed () {
      if (this.hovered === null) { return }
      this.setSelected(this.hovered)
    },
    setSelected (option) {
      if (option) {
        if (this.selectValue) {
          this.model = option[this.selectValue]
        } else {
          this.model = option
        }
        this.selected = option
        this.hovered = option
        this.isActive = false
      } else {
        this.model = null
        this.selected = null
        this.hovered = null
      }
    },
    setHovered (option) {
      if (option === undefined) { return }

      this.hovered = option
    },
    keyArrows (direction) {
      const sum = direction === 'down' ? 1 : -1
      if (this.isActive) {
        let index = this.data.indexOf(this.hovered) + sum
        index = index > this.data.length - 1 ? this.data.length : index
        index = index < 0 ? 0 : index

        this.setHovered(this.data[index])

        const list = this.$refs.dropdown.querySelector('.dropdown-content')
        const element = list.querySelectorAll('a.dropdown-item:not(.is-disabled)')[index]

        if (!element) { return }

        const visMin = list.scrollTop
        const visMax = list.scrollTop + list.clientHeight - element.clientHeight

        if (element.offsetTop < visMin) {
          list.scrollTop = element.offsetTop
        } else if (element.offsetTop >= visMax) {
          list.scrollTop = (
            element.offsetTop - list.clientHeight + element.clientHeight
          )
        }
      } else {
        this.isActive = true
      }
    },
    clickedOutside (event) {
      if (!this.whiteList.includes(event.target)) { this.isActive = false }
    }
  }
}
</script>
